import { render, staticRenderFns } from "./CatalogSchema.vue?vue&type=template&id=23609845"
import script from "./CatalogSchema.vue?vue&type=script&lang=js"
export * from "./CatalogSchema.vue?vue&type=script&lang=js"
import style0 from "./CatalogSchema.vue?vue&type=style&index=0&id=23609845&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports